import { apolloService } from '../../../services';
import { LOG_PAGE_VIEW } from '../../mutations/LOG_PAGE_VIEW';


export const logPageView = ( { pageType, pageUrl } ) => {

    apolloService.mutate( {
        mutation: LOG_PAGE_VIEW,
        variables: {
            pageUrl,
            pageType
        }
    } ).catch( err => {
        console.error( 'Unable to log Pageview event\n', err );
    } );
};